import { useLayoutEffect } from 'react'
import useDimmed from '@hooks/Interface/useDimmed'
import { useDarkModeControl } from '@hooks/useDarkModeControl'

const useAppNavigationBar = () => {
	const darkMode = useDarkModeControl()
	const { setDefaultDimmed } = useDimmed()

	useLayoutEffect(() => {
		setDefaultDimmed()
	}, [darkMode, setDefaultDimmed])
}
export default useAppNavigationBar
